import axios from '@/lib/axios';
import type { ConfiguracoesCliente } from '@/lib/config-geral';

export interface CheckAuthResponse {
  authenticated: boolean;
  user?: {
    id: number;
    username: string;
    nome_completo: string | null;
    email: string | null;
    foto_url: string | null;
  } | null;
  permissoes?: { modulo: string; permissao: string }[];
  homeMostrarModulosSemAcesso?: boolean;
  localTipo?: 'multi_empresa' | 'empresa_unica';
}

/**
 * Service de autenticação — endpoints /api/auth/*.
 * Cada função retorna o payload já desempacotado (response.data).
 */

export async function login(payload: Record<string, any>) {
  const { data } = await axios.post('/api/auth/login', payload);
  return data;
}

export async function logout() {
  const { data } = await axios.post('/api/auth/logout');
  return data;
}

export async function checkAuth() {
  const { data } = await axios.get<CheckAuthResponse>('/api/auth/check');
  return data;
}

export async function esqueciSenha(payload: Record<string, any>) {
  const { data } = await axios.post('/api/auth/esqueci-senha', payload);
  return data;
}

export async function trocarSenha(payload: Record<string, any>) {
  const { data } = await axios.post('/api/auth/trocar-senha', payload);
  return data;
}

export async function validarRedefinirSenha(params: Record<string, any>) {
  const { data } = await axios.get('/api/auth/redefinir-senha/validar', { params });
  return data;
}

export async function redefinirSenha(payload: Record<string, any>) {
  const { data } = await axios.post('/api/auth/redefinir-senha', payload);
  return data;
}
